import type { Theme } from '@mui/material';

export const styles = {
  paper: (theme: Theme) => ({
    [theme.breakpoints.up('md')]: {
      width: '100%',
      // overwrite mui max-width setting
      maxWidth: '700px',
    },
  }),
  modalContent: {
    fontSize: 12,
    width: '100%',
    position: 'relative',
  },

  commentsDownload: (theme: Theme) => ({
    paddingTop: 0,
    paddingRight: theme.spacing(6),
  }),

  noComments: (theme: Theme) => ({
    height: '100px',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(2),
    color: theme.palette.text.secondary,
  }),

  commentBox: (theme: Theme) => ({
    display: 'flex',
    border: 'solid 2px',
    borderColor: theme.colors.neutral[200],
    borderRadius: '0 1rem 1rem',
    marginY: theme.spacing(3),
  }),

  overallSentiment: (theme: Theme) => ({
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'center',
    width: '8%',
    margin: theme.spacing(1),
    marginTop: theme.spacing(2),
  }),

  comment: (theme: Theme) => ({
    width: '90%',
    margin: theme.spacing(1.5),
    marginLeft: 0,
  }),

  commentText: (theme: Theme) => ({
    fontSize: '14px',
    color: theme.palette.text.primary,
  }),

  commentTopicList: {
    display: 'flex',
    flexWrap: 'wrap',
  },

  commentTopic: (theme: Theme) => ({
    border: 'solid 1px',
    borderColor: theme.colors.neutral[600],
    borderRadius: '8px',
    display: 'flex',
    paddingY: theme.spacing(1),
    paddingX: theme.spacing(1.5),
    marginRight: theme.spacing(0.5),
    marginY: theme.spacing(0.5),
  }),

  commentTopicLabel: (theme: Theme) => ({
    whiteSpace: 'nowrap',
    fontSize: '11px',
    color: theme.palette.text.secondary,
    lineHeight: '15px',
  }),

  sentimentIcon: (theme: Theme) => ({
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(2),
  }),

  commentsSearch: (theme: Theme) => ({
    marginBottom: 4,
    paddingX: theme.spacing(0.5),
  }),

  spinnerBox: (theme: Theme) => ({
    display: 'flex',
    justifyContent: 'center',
    paddingY: theme.spacing(3),
  }),

  scrollBox: {
    margin: '1.25rem 0',
  },

  infiniteScroll: {
    maxHeight: '50vh',
    paddingRight: '2rem',
  },
};
